// src/hooks/usePageScroll.ts
// Упрощённая версия — скролл теперь управляется KeepAliveRoutes.
// Хук отвечает только за: обновление сессии + колбэк onActivate.

import { useEffect } from 'react';
import { supabase } from '../services/supabase';

export function usePageScroll(key: string, onActivate?: () => void) {
    useEffect(() => {
        supabase.auth.refreshSession().catch(() => {});
        onActivate?.();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
